export default __webpack_public_path__ + "cover.2c4c6eaa6aca101ba308977e1b7cd1bc.jpg"